import { Dispatch, SetStateAction, useCallback, useContext, useEffect, useState } from "react";
import { TeamContext, UserContext } from "../context/index";

import placeholder from "../assets/icons/placeholder.png";
import { IPlayer } from "../interfaces";

interface IUserData { 
    teamNumber: any; 
    email: any; 
    fullName: any; 
    nickname: string;
    profileIcon: any; 
    color: string; 
    isReady: boolean; 
}

const useCreateUser = () : [ IUserData, Dispatch<SetStateAction<IUserData>>, string | undefined, (name: string) => void] => {
    const { setAllTeamNames, enterTheTeam } = useContext(TeamContext);
    const { currentlyInputedUserData } = useContext(UserContext);
    const { game, gameCount } = useContext(TeamContext);

    let randomGeneratedTwoLetters = Math.random().toString(36).substr(10);
    let arrayOfRandomNames = ["Liam", "Noah", "Oliver", "William", "Elijah", "James", "Benjamin", "Lucas", "Maria", "Victoria"];
    let randomNumber = Math.floor(Math.random() * 10);

    const isThereUserColor: any = game?.players?.find( (player: IPlayer) => {return player?.email === currentlyInputedUserData?.email})?.color;
    const userColor: string = isThereUserColor ? isThereUserColor : "pink";

    const [team, setTeam] = useState<string>();

    const [loginData, setLoginData] = useState({
        teamNumber: currentlyInputedUserData ? currentlyInputedUserData.gameId : 0,
        email: currentlyInputedUserData ? currentlyInputedUserData.player.email : "",
        fullName: currentlyInputedUserData ? currentlyInputedUserData.player.name : "",
        nickname: currentlyInputedUserData ? currentlyInputedUserData.player.nickname : "",
        profileIcon: currentlyInputedUserData ? currentlyInputedUserData.player.image : placeholder,
        color: userColor,
        isReady: false,
    });

    const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];

    const setAllTeamnamesFromResponse = useCallback(() => {
      	fetch(process.env.REACT_APP_ADMIN_API + "api/matches/" + urlTokenExtracted + "/games/free")
			.then((response) => {
				if (!response.ok)
					throw Error(response.statusText);
				return response.json();
			})
			.then((res) => {
				let gameId = res[0].gameId;
				setTeam(gameId);
				setAllTeamNames(res);
			})
			.catch((err) => console.error(err));
    }, [setAllTeamNames, urlTokenExtracted])

    useEffect(() => {
      	setAllTeamnamesFromResponse();
    }, [setAllTeamnamesFromResponse]);

	const setInitialLoginData = useCallback(() => {
		let gameCounter = 0;

        if(gameCount)
			for(let i = 0; i < gameCount; i++) 
				gameCounter+=1;

        let randomTeamNumber = Math.floor(Math.random()*(gameCounter-1))+1;
        
        enterTheTeam( randomTeamNumber.toString() );
        
        setLoginData({
			...loginData,
			teamNumber: randomTeamNumber,
        })
	// "loginData" will cause a BUG, the user will not be able to enter the eMail.
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [enterTheTeam, gameCount])

    useEffect( () => {
        setInitialLoginData()
    }, [setInitialLoginData]);

    return [loginData, setLoginData, team, setTeam];
}

export default useCreateUser;